var _rect, _title, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g0, _g1, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhiteChip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {},
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "backgroundrect",
    width: "100%",
    height: "100%",
    x: 0,
    y: 0,
    fill: "none",
    stroke: "none"
  })), /*#__PURE__*/React.createElement("g", {
    className: "currentLayer",
    style: {}
  }, _title || (_title = /*#__PURE__*/React.createElement("title", null, "Layer 1")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svg_1",
    className: "",
    transform: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_2",
    transform: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.57681584358215,164.5850067138672 c-5.315999984741211,0 -9.625,4.309999942779541 -9.625,9.625 v212.22999572753906 H187.9128143787384 c-5.315999984741211,0 -9.625,4.309999942779541 -9.625,9.625 s4.309999942779541,9.625 9.625,9.625 h208.66400146484375 c5.315999984741211,0 9.625,-4.309999942779541 9.625,-9.625 V174.2100067138672 C406.2028229236603,168.8939971923828 401.8928253650665,164.5850067138672 396.57681584358215,164.5850067138672 z",
    id: "svg_3",
    transform: "",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "svg_4",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_5",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396.064,106.311H115.937c-5.316,0-9.625,4.31-9.625,9.625v280.127c0,5.316,4.31,9.625,9.625,9.625h39.405    c5.316,0,9.625-4.31,9.625-9.625s-4.31-9.625-9.625-9.625h-29.78V125.562h260.876v16.562c0,5.316,4.31,9.625,9.625,9.625    s9.625-4.31,9.625-9.625v-26.188C405.69,110.621,401.38,106.311,396.064,106.311z",
    id: "svg_6",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "svg_7",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_8",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M281.356,153.342h-114.31c-5.316,0-9.625,4.31-9.625,9.625c0,5.316,4.31,9.625,9.625,9.625h114.31    c5.316,0,9.625-4.31,9.625-9.625C290.982,157.652,286.672,153.342,281.356,153.342z",
    id: "svg_9",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "svg_10",
    className: "selected",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_11",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M217.096,194.441h-50.049c-5.316,0-9.625,4.31-9.625,9.625c0,5.316,4.31,9.625,9.625,9.625h50.049    c5.316,0,9.625-4.31,9.625-9.625C226.721,198.751,222.412,194.441,217.096,194.441z",
    id: "svg_12",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "svg_13",
    className: "",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "svg_14",
    fill: "#ffffff",
    fillOpacity: 1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M512,186.057c0-5.316-4.31-9.625-9.625-9.625h-39.438v-50.694h39.438c5.316,0,9.625-4.31,9.625-9.625    s-4.31-9.625-9.625-9.625h-39.438V58.69c0-5.316-4.31-9.625-9.625-9.625h-47.796V9.626c0-5.316-4.31-9.625-9.625-9.625    s-9.625,4.31-9.625,9.625v39.438H335.57V9.626c0-5.316-4.31-9.625-9.625-9.625c-5.316,0-9.625,4.31-9.625,9.625v39.438h-50.694    V9.626c0-5.316-4.31-9.625-9.625-9.625c-5.316,0-9.625,4.31-9.625,9.625v39.438h-50.694V9.626c0-5.316-4.31-9.625-9.625-9.625    s-9.625,4.31-9.625,9.625v39.438h-50.694V9.626c0-5.316-4.31-9.625-9.625-9.625c-5.316,0-9.625,4.31-9.625,9.625v39.438H58.689    c-5.316,0-9.625,4.31-9.625,9.625v47.796H9.625c-5.316,0-9.625,4.31-9.625,9.625s4.31,9.625,9.625,9.625h39.438v50.694H9.625    C4.31,176.43,0,180.74,0,186.056s4.31,9.625,9.625,9.625h39.438v50.694H9.625C4.31,246.375,0,250.684,0,256    c0,5.316,4.31,9.625,9.625,9.625h39.438v50.694H9.625c-5.316,0-9.625,4.31-9.625,9.625s4.31,9.625,9.625,9.625h39.438v50.694    H9.625c-5.316,0-9.625,4.31-9.625,9.625s4.31,9.625,9.625,9.625h39.438v47.796c0,5.316,4.31,9.625,9.625,9.625h47.797v39.438    c0,5.316,4.31,9.625,9.625,9.625s9.625-4.31,9.625-9.625v-39.438h50.694v39.438c0,5.316,4.31,9.625,9.625,9.625    s9.625-4.31,9.625-9.625v-39.438h50.694v39.438c0,5.316,4.31,9.625,9.625,9.625c5.316,0,9.625-4.31,9.625-9.625v-39.438h50.694    v39.438c0,5.316,4.31,9.625,9.625,9.625c5.316,0,9.625-4.31,9.625-9.625v-39.438h50.694v39.438c0,5.316,4.31,9.625,9.625,9.625    s9.625-4.31,9.625-9.625v-39.438h47.796c5.316,0,9.625-4.31,9.625-9.625v-47.796h39.438c5.316,0,9.625-4.31,9.625-9.625    s-4.31-9.625-9.625-9.625h-39.438V335.57h39.438c5.316,0,9.625-4.31,9.625-9.625c0-5.316-4.31-9.625-9.625-9.625h-39.438v-50.694    h39.438c5.316,0,9.625-4.31,9.625-9.625s-4.31-9.625-9.625-9.625h-39.438v-50.694h39.438v0.001    C507.69,195.682,512,191.373,512,186.057z M443.685,443.686H68.315V68.315h375.371V443.686z",
    id: "svg_15",
    fill: "#ffffff",
    fillOpacity: 1
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "svg_16"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "svg_17"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "svg_18"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "svg_19"
  })), _g0 || (_g0 = /*#__PURE__*/React.createElement("g", {
    id: "svg_20"
  })), _g1 || (_g1 = /*#__PURE__*/React.createElement("g", {
    id: "svg_21"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "svg_22"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "svg_23"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "svg_24"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "svg_25"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    id: "svg_26"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    id: "svg_27"
  })), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    id: "svg_28"
  })), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    id: "svg_29"
  })), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    id: "svg_30"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteChip);
export default __webpack_public_path__ + "static/media/white_chip.88d34b778ce32044bb334e6352114063.svg";
export { ForwardRef as ReactComponent };